import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { DayPartingInputsComponent } from "@m19-board/strategies/day-parting-inputs/day-parting-inputs.component";
import { TranslocoDirective } from "@jsverse/transloco";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { DaypartingConfig, DaypartingService } from "@m19-board/services/dayparting.service";
import { SpStrategyEx } from "@front/m19-models/strategy/SpStrategyEx";

@Component({
  selector: "app-day-parting-pop-up",
  templateUrl: "./day-parting-pop-up.component.html",
  styleUrls: ["./day-parting-pop-up.component.scss"],
  imports: [TranslocoDirective, DayPartingInputsComponent, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayPartingPopUpComponent {
  protected readonly modalData = inject<DayPartingPopUpData>(MODAL_DATA);
  protected readonly modalRef = inject(ModalRef);
  protected readonly daypartingService = inject(DaypartingService);

  strategy = this.modalData.strategy;

  daypartingConfig = signal<DaypartingConfig | undefined>({
    strategy: this.modalData.strategy,
    organizationId: this.modalData.organizationId,
    daypartingPauseHour: this.modalData.dayPartingPauseHour ?? 22,
    daypartingReactivationHour: this.modalData.dayPartingReactivationHour ?? 8,
    enabledDayParting:
      this.modalData.dayPartingPauseHour !== undefined && this.modalData.dayPartingReactivationHour !== undefined,
  });
  isUpdatingDayparting = signal(false);

  onSave(): void {
    if (!this.daypartingConfig()) return;
    this.isUpdatingDayparting.set(true);
    this.daypartingService.saveConfig(this.daypartingConfig()!).subscribe(() => {
      this.modalRef.close();
    });
  }
}

export interface DayPartingPopUpData {
  strategy: SpStrategyEx;
  organizationId: number;
  currencyCode: string;
  locale: string;
  dayPartingPauseHour?: number;
  dayPartingReactivationHour?: number;
}
